import React, { Fragment } from 'react'
import { Table } from 'antd'
import { Goods } from '@/model/types/goods'
import { ColumnsType } from 'antd/lib/table/Table'
import { $post } from '@/api'
import { isArray } from 'util'
import { formatTime } from '@/utils'
import { WithScrollLoad, isNoMore } from '@/utils/utils-widget'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'

interface IProps {
    goodsId: number
}

interface IStockChangeRecord {
    change_time: string
    goods: Goods
    order_no: number
    reason: number
    stock_after_change: number
    stock_changed: number
}

export const StockChangeRecord: React.FC<IProps> = props => {
    const requestHandle = useRequest<
        {
            list: IStockChangeRecord[]
            pagination: IPagination
        },
        {
            records: IStockChangeRecord[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/goods/getgoodsstockchangerecords',
                params: {
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    limit: 20,
                    goods_id: props.goodsId,
                },
            })
        },
        {
            isNoMore: isNoMore,
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.records,
                    pagination: data.pagination,
                }
            },
        },
    )

    const columns: ColumnsType<IStockChangeRecord> = [
        {
            title: '#',
            align: 'center',
            width: '40px',
            key: '#',
            render: (text, record, index) => <div>{index + 1}</div>,
        },
        {
            title: '时间',
            render: (text, record) => (
                <div data-column>
                    {!isArray(formatTime(record.change_time)) ? (
                        // 需要根据实际数据处理
                        <span>{formatTime(record.change_time)}</span>
                    ) : (
                        <Fragment>
                            <span>{formatTime(record.change_time)[0]}</span>
                            <span>{formatTime(record.change_time)[1]}</span>
                        </Fragment>
                    )}
                </div>
            ),
        },
        {
            title: '变更类型',
            key: 'reason',
            dataIndex: 'reason',
            render: text => <div>{stockChangeType(text)}</div>,
        },
        {
            title: '变更库存',
            key: '',
            align: 'right',
            dataIndex: 'stock_changed',
            render: (value, record) => (
                <span className={[value < 0 ? 'danger-color' : ''].join(' ')}>
                    {value > 0 ? '+' : ''}
                    {value}
                    {record.goods.stock_unit.name}
                </span>
            ),
        },
        {
            title: '剩余库存',
            align: 'right',
            key: 'stock_after_change',
            dataIndex: 'stock_after_change',
            render: (value, record) => (
                <span className={[value < 0 ? 'danger-color' : ''].join(' ')}>
                    {value > 0 ? '+' : ''}
                    {value}
                    {record.goods.stock_unit.name}
                </span>
            ),
        },
    ]

    return (
        <div data-margin-top-10>
            <WithScrollLoad scrollloadhandle={requestHandle}>
                <Table
                    rowKey={record => record.order_no}
                    columns={columns}
                    dataSource={requestHandle.data?.list}
                    pagination={false}
                    bordered
                    loading={requestHandle.loadingMore || requestHandle.loading || void 0}
                    scroll={{ y: '400px' }}
                ></Table>
            </WithScrollLoad>
        </div>
    )
}

export function stockChangeType(type: number) {
    // 库存变更原因 {"0": "未知原因", "1": "初始化库存", "2": "入库", "3": "销售扣减库存", "4": "退款退还库存", "5": "取消订单退还库存"}
    switch (type) {
        case 0:
            return '未知原因'
        case 1:
            return '设置初始库存'
        case 2:
            return '商品入库'
        case 3:
            return '商品销售'
        case 4:
            return '商品退款'
        case 5:
            return '取消订单'
        case 6:
            return '库存盘点'
        case 7:
            return '商品报损'
        case 8:
            return '采购退货'
        case 9:
            return '门店配货补款'
        case 10:
            return '门店配货退款'
        case 11:
            return '套餐销售'
        case 12:
            return '撤销入库'
        case 13:
            return '后台挂单'
        case 14:
            return '处理挂单'
        case 15:
            return '调拨调出'
        case 16:
            return '调拨退回'
        case 17:
            return '抖音核销'
        case 18:
            return '抖音核销撤销'
    }
}
